import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-groupInfo-2",
  "use": "icon-groupInfo-2-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-groupInfo-2\">\n  <path id=\"icon-groupInfo-2_路径_9186\" data-name=\"路径 9186\" d=\"M0,2.154H2V4.308H0ZM12,9.692h2v2.154H12Zm-12,0H6v2.154H0ZM8,2.154h6V4.308H8V2.154ZM8,7.538h2V14H8V7.538ZM4,0H6V6.462H4Z\" fill=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/groupInfo-2.svg
// module id = oydD
// module chunks = 103